// extracted by mini-css-extract-plugin
module.exports = {"top":"pricing_top__rYfo0","page_title":"pricing_page_title__Nihq_","page_description":"pricing_page_description__KZ9Zi","subtitle":"pricing_subtitle__0gRUp"};